<script>
  export let yaoColor = ""
  export let lastYao = ""
  export let size = ""

  // console.log("@ YangYao: size is " + size)
</script>

{#if size == "medium"}
  <div class="inline">
    {#if yaoColor == "unstable"}
      <div class="m-yang-yao-unstable" />
    {:else if yaoColor == "change"}
      <div class="m-yang-yao-change" />
    {:else}
      <div class="m-yang-yao-static" />
    {/if}
  </div>
{:else if size == "size2"}
  <div class="inline">
    {#if yaoColor == "unstable"}
      <div class="s2-yang-yao-unstable" />
    {:else if yaoColor == "change"}
      <div class="s2-yang-yao-change" />
    {:else}
      <div class="s2-yang-yao-static" />
    {/if}
  </div>
{:else}
  <div class="inline">
    {#if yaoColor == "unstable"}
      <div class="yang-yao-unstable" />
    {:else if yaoColor == "change"}
      <div class="yang-yao-change" />
    {:else}
      <div class="yang-yao-static" />
    {/if}
  </div>
{/if}

<style>
  .inline {
    display: flex;
    justify-content: center;
  }
  .yang-yao-unstable {
    width: 35px;
    height: 5px;
    background-color: #774477;
    margin: 3px 0;
  }
  .yang-yao-change {
    width: 35px;
    height: 5px;
    background-color: #ee1122;
    margin: 3px 0;
  }
  .yang-yao-static {
    width: 35px;
    height: 5px;
    background-color: #222222;
    margin: 3px 0;
  }

  /* Medium size */
  .m-yang-yao-unstable {
    width: 70px;
    height: 10px;
    background-color: #774477;
    margin: 6px 0;
  }
  .m-yang-yao-change {
    width: 70px;
    height: 10px;
    background-color: #ee1122;
    margin: 6px 0;
  }
  .m-yang-yao-static {
    width: 70px;
    height: 10px;
    background-color: #222222;
    margin: 6px 0;
  }

  /* Size: size2 */
  .s2-yang-yao-unstable {
    width: 60px;
    height: 9px;
    background-color: #774477;
    margin: 4px 0;
  }
  .s2-yang-yao-change {
    width: 60px;
    height: 9px;
    background-color: #ee1122;
    margin: 4px 0;
  }
  .s2-yang-yao-static {
    width: 60px;
    height: 9px;
    background-color: #222222;
    margin: 4px 0;
  }
</style>
